import { render, staticRenderFns } from "./TableZone.vue?vue&type=template&id=47779d07&scoped=true&"
import script from "./TableZone.vue?vue&type=script&lang=js&"
export * from "./TableZone.vue?vue&type=script&lang=js&"
import style0 from "./TableZone.vue?vue&type=style&index=0&id=47779d07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47779d07",
  null
  
)

export default component.exports